import { useAsyncData } from '@redneckz/uni-jsx/lib/hooks/useAsyncData';
import { fetchJSONUnsafe } from '../../utils/fetchJSON.js';
const DEPOSIT_RATES_SERVICE_MAP = {
    UL: 'businessdepositrates',
    IP: 'selfemployeddepositrates',
};
export function useBusinessDepositRates(rateParams) {
    const serviceName = rateParams?.rateType ? DEPOSIT_RATES_SERVICE_MAP[rateParams?.rateType] : '';
    const { data } = useAsyncData(serviceName ? `/api/v1/depositrates/${serviceName}` : null, fetchJSONUnsafe);
    return Array.isArray(data) ? data : [];
}
//# sourceMappingURL=useBusinessDepositRates.js.map